import { render, staticRenderFns } from "./TestAttestingModal.vue?vue&type=template&id=68fc5ee7&scoped=true&"
import script from "./TestAttestingModal.vue?vue&type=script&lang=js&"
export * from "./TestAttestingModal.vue?vue&type=script&lang=js&"
import style0 from "./TestAttestingModal.vue?vue&type=style&index=0&id=68fc5ee7&lang=scss&scoped=true&"
import style1 from "./TestAttestingModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fc5ee7",
  null
  
)

export default component.exports